import { Outlet, RouteObject } from "react-router-dom";

import AuthLayout from "../components/Layout/Auth";
import AuthenticatedLayout from "../components/Layout/Authenticated";

import Login from "../pages/Auth/Login";
import SignUp from "../pages/Auth/SignUp";
import FindId from "../pages/Auth/FindId";
import FindIdComplete from "../pages/Auth/FindId/Complete";
import FindPassword from "../pages/Auth/FindPassword";
import ResetPassword from "../pages/Auth/FindPassword/ResetPassword";

import Talk from "../pages/Talk";
import Center from "../pages/Center";
import View from "../pages/View";
import ViewSearch from "../pages/View/Search";
import BuildingInfo from "../pages/View/BuildingInfo";

import TalkDetailPage from "../pages/Talk/Detail";
import TalkNewPost from "../pages/Talk/NewPost";
import TalkOutlet from "../components/Talk/Outlet";
import TalkEditPost from "../pages/Talk/EditPost";
import TalkReport from "../pages/Talk/Report";
import TotalServices from "../pages/TotalService";
import TalkSearch from "../pages/Talk/Search";
import Toilet from "../pages/Manager/Toilet";
import ReviewStore from "../pages/Talk/ReviewStore";

import MyInfo from "../pages/MyInfo";
import MyInfoChangeEmail from "../pages/MyInfo/ChangeEmail";
import MyInfoChangeBuilding from "../pages/MyInfo/ChangeBuilding";
import MyInfoChangePassword from "../pages/MyInfo/ChangePassword";
import ConfigSimpleLogin from "../pages/MyInfo/ConfigSimpleLogin";
import ConfigBiometricAuthentication from "../pages/MyInfo/ConfigBiometricAuthentication";
import MyInfoConfig from "../pages/MyInfo/Config";
import MyInfoCertificationCompany from "../pages/MyInfo/CertificationCompany";
import MyInfoCertIdentity from "../pages/MyInfo/CertIdentity";
import MyInfoConfigPushUser from "../pages/MyInfo/Config/PushUser";
import MyInfoConfigPushManager from "../pages/MyInfo/Config/PushManager";
import AppInfo from "../pages/MyInfo/Config/AppInfo";
import MyInfoFaq from "../pages/MyInfo/Faq";

import ServiceNotFound from "../pages/Services/NotFound";
import ServiceCallback from "../pages/Services/Callback";
import CallbackSspPage from "../pages/Services/Callback/Ssp";

import History from "../pages/History";
import HistoryReport from "../pages/History/Incommodity";
import HistoryReservation from "../pages/History/Reservation";
import HistoryRent from "../pages/History/Rent";
import HistoryRentSuccess from "../pages/History/Rent/Success";
import HistoryService from "../pages/History/Service";

import ManagerReport from "../pages/Manager/Report";
import ManagerReportDetail from "../pages/Manager/Report/Detail";
import ManagerTempHumid from "../pages/Manager/TempHumid";
import ManagerAir from "../pages/Manager/Air";

import RentalStockControl from "../pages/Manager/RentalManager/RentalStock/Control";
import RentalStockConnect from "../pages/Manager/RentalManager/RentalStock/Connect";
import RentalStockCreate from "../pages/Manager/RentalManager/RentalStock/Create";

import ManagerRentalManager from "../pages/Manager/RentalManager";
import ManagerRentalManagerDetail from "../pages/Manager/RentalManager/Detail";

import ManagerHotColdVote from "../pages/Manager/HotColdVote";
import ManagerHotColdVoteDetail from "../pages/Manager/HotColdVote/Detail";
import ManagerHotColdVoteFeedback from "../pages/Manager/HotColdVote/Feedback";

import Alarm from "../pages/Alarm";

import SpaceReservation from "../pages/Services/SpaceReservation";
import SpaceReservationDetail from "../pages/Services/SpaceReservation/Detail";
import SpaceReservationCreate from "../pages/Services/SpaceReservation/Create";
import SpaceReservationConfirmed from "../pages/Services/SpaceReservation/Confirmed";
import SpaceReservationWaiting from "../pages/Services/SpaceReservation/Waiting";
import ToiletEmpty from "../pages/Services/ToiletEmpty";
import GoodsRequest from "../pages/Services/GoodsRequest";
import GoodsRequestConfirm from "../pages/Services/GoodsRequest/Confirmed";

import OpenTerm from "../pages/Term";
import PastTerms from "../pages/Term/PastTerms";

import MemberShipCard from "../pages/Services/MemberShipCard";
import MemberShipCardUsage from "../pages/Services/MemberShipCard/Usage";

import ServiceRental from "../pages/Services/Rental";
import ServiceRentalRedirect from "../pages/Services/RentalRedirect";
import ServiceRentalDetail from "../pages/Services/Rental/Detail";
import ServiceRentalRequested from "../pages/Services/Rental/Requested";
import ServiceRentalRented from "../pages/Services/Rental/Rented";
import ServiceRentalReturned from "../pages/Services/Rental/Returned";

import HotColdVoteDetail from "../pages/Services/HotColdVote/Detail";
import HotColdVote from "../pages/Services/HotColdVote";

import CustomService from "../pages/Services/Custom";

import ManagerRentalManagerSatisfaction from "../pages/Manager/RentalManager/Satisfaction";

import AppInstall from "../pages/AppInstall";
import Maintenance from "../pages/Maintenance";

import { mainNavIcon } from "../svgs/mainNavIcon";
import Situation from "../pages/Emergency/Situation";
import VacationResult from "../pages/Emergency/Result/Vacation";
import HelpResult from "../pages/Emergency/Result/Help";
import EvacuationResult from "../pages/Emergency/Result/Evacuation";
import Uncert from "../components/Layout/Uncertified";
import EmergencyManagerSituationList from "../pages/Emergency/Manager/Situation/List";
import UncertSituation from "../pages/Emergency/Uncert/Situation";
import EmergencyAlarm from "../pages/Emergency/Alarm";
import EmergencyManagerSituationDetail from "../pages/Emergency/Manager/Situation/Detail";
import DoneResult from "../pages/Emergency/Result/Done";
import ConfirmQrMake from "../pages/Emergency/Manager/Situation/ConfirmQrMake";
import AdvertisingBluetooth from "../pages/Emergency/Confirm/Bluetooth";
import EvacuationManagerGuard from "../components/Layout/EvacuationManagerGuard";
import AuthGuard from "../components/Layout/AuthGuard";
import SmartOffice from "../pages/SmartOffice";
import FaqDetailPage from "../pages/MyInfo/Faq/FaqDetail";

export type RouteInfo = Omit<RouteObject, "children"> & {
  title?: string;
  children?: RouteInfo[];
  icon?: React.ReactNode;
  activeIcon?: React.ReactNode;
};

export const routes: RouteInfo[] = [
  {
    path: "",
    title: "Home",
    element: <AuthenticatedLayout />,
    children: [
      { index: true, element: <View /> },
      {
        path: "service",
        title: "전체 서비스",
        children: [
          { index: true, element: <TotalServices /> },
          {
            path: "space-reservation",
            children: [
              {
                index: true,
                element: <SpaceReservation />,
              },
              {
                path: "detail/:id/:date",
                element: <SpaceReservationDetail />,
              },
              {
                path: "create/:id",
                element: <SpaceReservationCreate />,
              },
              {
                path: "waiting/:id",
                element: <SpaceReservationWaiting />,
              },
              {
                path: "confirmed/:id",
                element: <SpaceReservationConfirmed />,
              },
            ],
          },
          {
            path: "goods",
            children: [
              { index: true, element: <GoodsRequest /> },
              { path: "confirmed", element: <GoodsRequestConfirm /> },
            ],
          },
          { path: "toilet-empty", element: <ToiletEmpty /> },
          {
            path: "membership-card",
            element: <Outlet />,
            children: [
              { index: true, element: <MemberShipCard /> },
              { path: "usage", element: <MemberShipCardUsage /> },
            ],
          },
          {
            path: "rental",
            element: <Outlet />,
            children: [
              { index: true, element: <ServiceRental /> },
              { path: "requested", element: <ServiceRentalRequested /> },
              { path: "rented", element: <ServiceRentalRented /> },
              { path: "returned", element: <ServiceRentalReturned /> },
              { path: ":id", element: <ServiceRentalDetail /> },
            ],
          },
          { path: "rental-umbrella", element: <ServiceRentalRedirect /> },
          { path: "rental-tools", element: <ServiceRentalRedirect /> },
          { path: "rental-book", element: <ServiceRentalRedirect /> },
          { path: "rental-item", element: <ServiceRentalRedirect /> },
          {
            path: "air-monitoring-user",
            element: <ManagerAir isManager={false} />,
          },
          {
            path: "custom",
            element: <CustomService />,
          },
          {
            path: "hot-cold-vote",
            element: <Outlet />,
            children: [
              { index: true, element: <HotColdVote /> },
              { path: "detail", element: <HotColdVoteDetail /> },
            ],
          },
          { path: "*", element: <ServiceNotFound /> },
        ],
        ...mainNavIcon.service,
      },
      {
        path: "talk",
        title: "샌디톡",
        element: <TalkOutlet />,
        children: [
          { index: true, element: <Talk /> },
          { path: ":id", element: <TalkDetailPage /> },
          { path: "newPost", element: <TalkNewPost /> },
          { path: "search", element: <TalkSearch /> },
          { path: "editPost/:id", element: <TalkEditPost /> },
          {
            path: "report",
            element: <Outlet />,
            children: [
              {
                path: "comment/:id",
                element: <TalkReport type="comment" />,
              },
              { path: "post/:id", element: <TalkReport type="post" /> },
            ],
          },
          { path: "store/:id", element: <ReviewStore /> },
        ],
        ...mainNavIcon.talk,
      },
      {
        path: "view",
        title: "샌디홈",
        element: <Outlet />,
        ...mainNavIcon.view,
        children: [
          { index: true, element: <View /> },
          { path: "search", element: <ViewSearch /> },
          { path: "buildingInfo/:id", element: <BuildingInfo /> },
        ],
      },
      {
        path: "report",
        title: "도와주세요",
        element: <Center />,
        ...mainNavIcon.report,
      },
      // { path: "pinezone", title: "샌디존", element: <div>샌디존</div>,  },
      {
        path: "myinfo",
        title: "내 정보",
        element: <Outlet />,
        ...mainNavIcon.myinfo,
        children: [
          { index: true, element: <MyInfo /> },
          { path: "change/email", element: <MyInfoChangeEmail /> },
          { path: "change/building", element: <MyInfoChangeBuilding /> },
          { path: "change/password", element: <MyInfoChangePassword /> },
          {
            path: "config/simple/login",
            element: <ConfigSimpleLogin />,
          },
          {
            path: "config/biometric/authentication",
            element: <ConfigBiometricAuthentication />,
          },
          { path: "cert/company", element: <MyInfoCertificationCompany /> },
          { path: "cert/identity", element: <MyInfoCertIdentity /> },
          {
            path: "config",
            element: <Outlet />,
            children: [
              { index: true, element: <MyInfoConfig /> },
              { path: "push/user", element: <MyInfoConfigPushUser /> },
              { path: "push/manager", element: <MyInfoConfigPushManager /> },
              { path: "app/info", element: <AppInfo /> },
            ],
          },
          { path: "faq", element: <Outlet />, children: [
            { index: true, element: <MyInfoFaq /> },
            { path: ":id", element: <FaqDetailPage /> },
          ] },
        ],
      },
      { path: "smart-office", element: <SmartOffice /> },
      {
        path: "manager",
        title: "매니저존",
        element: <Outlet />,
        children: [
          {
            path: "toilet-monitoring",
            title: "화장실 모니터링",
            element: <Toilet />,
          },
          {
            path: "voc-manager",
            element: <Outlet />,
            children: [
              { index: true, element: <ManagerReport /> },
              { path: "detail/:id", element: <ManagerReportDetail /> },
            ],
          },
          { path: "temperature-monitoring", element: <ManagerTempHumid /> },
          { path: "air-monitoring", element: <ManagerAir /> },
          {
            path: "rental-manager",
            title: "대여 관리",
            children: [
              { index: true, element: <ManagerRentalManager /> },
              {
                path: "rental-stock",
                children: [
                  { index: true, element: <ServiceNotFound /> },
                  { path: "control", element: <RentalStockControl /> },
                  { path: "connect", element: <RentalStockConnect /> },
                  { path: "create", element: <RentalStockCreate /> },
                ],
              },
              {
                path: "satisfaction",
                element: <ManagerRentalManagerSatisfaction />,
              },
              { path: ":id", element: <ManagerRentalManagerDetail /> },
            ],
          },
          {
            path: "evacuation-manager",
            element: <EvacuationManagerGuard />,
            children: [
              { index: true, element: <EmergencyManagerSituationList /> },
              { path: "confirm-qr", element: <ConfirmQrMake /> },
              { path: "confirm-ble", element: <AdvertisingBluetooth /> },
              {
                path: ":id",
                element: <EmergencyManagerSituationDetail />,
              },
            ],
          },
          {
            path: "manager-hot-cold-vote",
            element: <Outlet />,
            children: [
              { index: true, element: <ManagerHotColdVote /> },
              { path: "detail", element: <ManagerHotColdVoteDetail /> },
              { path: "feedback/:id", element: <ManagerHotColdVoteFeedback /> },
            ],
          },
          {
            path: "custom",
            element: <CustomService />,
          },
          { path: "*", element: <ServiceNotFound /> },
        ],
      },
      {
        path: "history",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <History />,
          },
          {
            path: "incommodity/:id",
            element: <HistoryReport />,
          },
          { path: "reservation/:id", element: <HistoryReservation /> },
          {
            path: "rent",
            element: <Outlet />,
            children: [
              { path: ":id", element: <HistoryRent /> },
              {
                path: "success/:id",
                element: <HistoryRentSuccess />,
              },
            ],
          },
          { path: "service/:id", element: <HistoryService /> },
        ],
      },
      { path: "alarm", element: <Alarm /> },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      { path: "login", element: <Login /> },
      { path: "logout", element: <div>Logout</div> },
      { path: "signUp", element: <SignUp /> },
      {
        path: "findId",
        element: <Outlet />,
        children: [
          { index: true, element: <FindId /> },
          { path: "complete", element: <FindIdComplete /> },
        ],
      },
      {
        path: "findPassword",
        element: <Outlet />,
        children: [
          { index: true, element: <FindPassword /> },
          { path: "resetPassword", element: <ResetPassword /> },
        ],
      },
    ],
  },
  {
    path: "callback",
    element: <ServiceCallback />,
    children: [{ path: "ssp", element: <CallbackSspPage /> }],
  },
  { path: "actuator", element: <div>status:ok</div> },
  { path: "term/:purpose", element: <OpenTerm /> },
  { path: "past-terms/:purpose", element: <PastTerms /> },
  { path: "app_install", element: <AppInstall /> },
  { path: "maintenance", element: <Maintenance /> },
  {
    path: "evacuation",
    element: (
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    ),
    children: [
      { path: "situation", element: <Situation /> },
      { path: "vacation-result", element: <VacationResult /> },
      { path: "help-result", element: <HelpResult /> },
      { path: "evacuation-result", element: <EvacuationResult /> },
      { path: "emergency-alarm", element: <EmergencyAlarm /> },
      { path: "done", element: <DoneResult /> },
    ],
  },
  {
    path: "uncert-evacuation",
    element: <Uncert />,
    children: [
      // 알림톡의 url이 /uncert-evacuation/{situationId}로 되어있음
      { path: ":id", element: <UncertSituation /> },
      { path: "vacation-result", element: <VacationResult /> },
      { path: "help-result", element: <HelpResult /> },
      { path: "evacuation-result", element: <EvacuationResult /> },
      { path: "done/:id", element: <DoneResult /> },
    ],
  },
  {
    path: "evacuation-manager",
    element: <EmergencyManagerSituationList />,
  },
  { path: "*", title: "Not Found", element: <ServiceNotFound /> },
];

export const getMainNavRoutes = () => {
  if (routes[0].children)
    return routes[0].children.filter((route) => route.index !== true);
  else return [];
};
